import React from 'react'
import image from '../../images/derindondurucu.png'
import DeleteSvg from '../svg/DeleteSvg'
import Counter from '../Counter'
import ManatSvg from '../svg/ManatSvg'

export default function Card15() {
    return (
        <div className='flex gap-[30px]  p-[30px] h-full bg-[#fff] rounded-[20px]'>
            <img src={image} className='w-[200px] h-[200px]' />


            <div className='flex flex-col justify-between w-full'>
                <div className='flex justify-between items-center min-w-fit'>
                    <h3 className='font-[500] text-[20px] leading-[100%] text-[#030303] '>Dolab Tipli Soyuducu </h3>

                    <button className='bg-[#f7f8fa] p-[10px] rounded-[12px]'>
                        <DeleteSvg />
                    </button>
                </div>
                <div className='flex  gap-[40px]'>
                    <Counter />
                    <div className='flex  gap-[4px]'>
                        <span className='font-[500] text-[24px] text-[#000] flex items-center'>109.0 AZN</span>

                    </div>
                </div>
            </div>
        </div>
    )
}
